import { Gem, Star, Sparkles, Flame } from "lucide-react";

const TIER_CONFIG = {
  Grail: {
    icon: Flame,
    label: "Grail",
    ring: "border-rose-500/40 bg-gradient-to-br from-rose-950/60 to-amber-950/40",
    text: "text-rose-400",
    accent: "text-rose-500",
    barFrom: "from-rose-500",
    barTo: "to-amber-500",
  },
  Rare: {
    icon: Sparkles,
    label: "Rare",
    ring: "border-amber-500/30 bg-amber-950/20",
    text: "text-amber-400",
    accent: "text-amber-500",
    barFrom: "from-amber-500",
    barTo: "to-rose-500",
  },
  Uncommon: {
    icon: Star,
    label: "Uncommon",
    ring: "border-emerald-500/30 bg-emerald-950/20",
    text: "text-emerald-400",
    accent: "text-emerald-500",
    barFrom: "from-emerald-500",
    barTo: "to-sky-500",
  },
  Common: {
    icon: Gem,
    label: "Common",
    ring: "border-zinc-700/50 bg-zinc-900/40",
    text: "text-zinc-400",
    accent: "text-zinc-300",
    barFrom: "from-zinc-500",
    barTo: "to-zinc-400",
  },
};

export default function RarityScoreBadge({ score }) {
  if (!score) return null;
  const cfg = TIER_CONFIG[score.tier] || TIER_CONFIG.Common;
  const Icon = cfg.icon;
  const ownersLabel = score.owners_count === 1 ? "1 collector" : `${score.owners_count} collectors`;

  return (
    <div data-testid="rarity-score-badge" className={`rounded-xl border p-5 backdrop-blur-xl ${cfg.ring}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className={`p-2 rounded-lg bg-zinc-950/50 border border-white/5 ${cfg.accent}`}>
            <Icon className="w-5 h-5" />
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-semibold">Rarity Score</p>
            <p className={`font-heading text-xl font-bold ${cfg.text} leading-tight`}>{cfg.label}</p>
          </div>
        </div>
        <div className="text-right">
          <p className="font-mono text-3xl font-bold text-zinc-100 leading-none">{score.score}</p>
          <p className="text-[10px] text-zinc-600 mt-1">/ 100</p>
        </div>
      </div>
      <div className="mt-4">
        <div className="h-1.5 bg-zinc-800 rounded-full overflow-hidden">
          <div
            className={`h-full bg-gradient-to-r ${cfg.barFrom} ${cfg.barTo} transition-all duration-500`}
            style={{ width: `${score.score}%` }}
          />
        </div>
        <p className="text-[11px] text-zinc-500 mt-2">Owned by {ownersLabel} on Castfolio</p>
      </div>
    </div>
  );
}
